import React, { useCallback, useState } from 'react';
import { IExtendedRestaurantNfcCards } from 'types';
import { NEW_NFC_CARDS_BLOCK_PREFIX } from 'appConstants';
import { Button } from 'antd';
import Text from 'components/Text/Text';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './AddNewBlockButton.module.scss';

interface IAddNewBlockButton {
	addNfcCardsBlock: (value: IExtendedRestaurantNfcCards) => void;
}

export const AddNewBlockButton: React.FC<IAddNewBlockButton> = React.memo(({ addNfcCardsBlock }) => {
	const [blockIDCounter, setBlockIDCounter] = useState(1);

	const handleClick = useCallback(() => {
		setBlockIDCounter((prevState) => prevState + 1);

		const blockId = `${NEW_NFC_CARDS_BLOCK_PREFIX}/${blockIDCounter}`;

		addNfcCardsBlock({
			id: blockId,
			uuid: '',
			cardHolder: '',
			permissions: [],
		});
	}, [blockIDCounter, addNfcCardsBlock]);

	return (
		<Button
			className={style.button}
			type="text"
			onClick={handleClick}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}>
			<Text translationNameSpace="form" translationKey="addNewBlockButton" asFragment={true} />
		</Button>
	);
});
